export enum ZoneType {
  LIVING_ZONE = 'W',
  WORKING_ZONE = 'A',
  MIXED_ZONE = 'M',
  CENTRAL_ZONE = 'Z',
  PUBLIC_ZONE = 'ON',
  RESTRICTED_CONSTRUCTION_ZONE = 'EB',
  TOURISM_ZONE = 'T',
  TRAFFIC_ZONE = 'V',
  OTHER_CONSTRUCTION_ZONE = 'WB',
  UNKNOWN_ZONE = 'U',
  NON_CONSTRUCTION_ZONE = 'NB',
}

export enum LawFieldType {
  INT = 'int',
  FLOAT = 'float',
  STRING = 'string',
  DEFINITION = 'def',
  BOOLEAN = 'boolean',
  DATE = 'date',
  MULTIPLE_CHOICE = 'multiple-choice',
  IVHB_CHOICE = 'ivhb-choice',
  STAIRCASE_CHOICE = 'staircase-choice',
}

export enum MultipleChoiceValue {
  TRUE = 'true',
  FALSE = 'false',
  PARTIALLY = 'partially',
}

export enum IvhbChoiceValue {
  TRUE = 'true',
  FALSE = 'false',
  PARTIALLY = 'partially',
  WITH_RESERVATIONS = 'with-reservations',
}

export enum StaircaseChoiceValue {
  TRUE = 'true',
  FALSE = 'false',
  TRUE_HNF_50 = 'true_hnf_50',
  TRUE_HNF = 'true_hnf',
}
